module.exports = __webpack_public_path__ + "img/RepairPending-trashCan.4d09f76a.png";